"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var material_1 = require("@angular/material");
var TokenExpiredDialogComponent = /** @class */ (function () {
    function TokenExpiredDialogComponent(dialogRef, data) {
        this.dialogRef = dialogRef;
        this.data = data;
    }
    TokenExpiredDialogComponent.prototype.closeAction = function () {
        this.dialogRef.close();
    };
    return TokenExpiredDialogComponent;
}());
exports.TokenExpiredDialogComponent = TokenExpiredDialogComponent;
